import { ToastContainer, toast } from "react-toastify";
import { useState, useEffect } from "react";
import "./Mantiq.css";
import CONFIG from "../config";
import { formatSumma } from "../utils/format";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../Rasm/logo.png";
import certificate_frame from "../Rasm/certificate_frame_v2.png";
import { FaShareSquare, FaStar, FaDownload, FaTimes, FaCheckCircle, FaCoins, FaLayerGroup, FaChessKnight, FaGem, FaFilePdf, FaFileImage, FaChartLine } from "react-icons/fa";
import { encodeCertId } from "../utils/crypto";




export default function Mantiq({ userData, darajalar, onStatsClick, triggerCert }) {
  // Default values from props
  const {
    tanga_balansi = 0,
    tanga_jami = 0, // Added gross balance
    fio: userFio = "Foydalanuvchi", // Get FIO from root user object
    rank = {}
  } = userData || {};

  const {
    completed_sections = 0,
    total_solved = 0,
    certificate_id = null,
    // fio from rank is ignored in favor of userFio if present, or we check both
    fio: rankFio
  } = rank;

  // Use rankFio if available (maybe specific rank name?), else userFio
  const displayFio = userFio && userFio !== "Foydalanuvchi" ? userFio : (rankFio || "Foydalanuvchi");

  const [showCert, setShowCert] = useState(false);
  const [bgLoaded, setBgLoaded] = useState(false);

  const titles = darajalar && darajalar.length > 0 ? darajalar : [
    "Piyoda", "Suvoriy", "Leytinant", "Kapitan", "Mayor",
    "Sharafli", "Kanoner", "General", "Amir", "Rasuljon"
  ];

  // Calculate Rank from userData.daraja
  const darajaRaw = userData?.daraja;
  let stars = 0;
  let title = "O'quvchi";

  if (darajaRaw) {
    if (typeof darajaRaw === 'number' || !isNaN(darajaRaw)) {
      const darajaLevel = parseInt(darajaRaw);
      // Adjusted: Piyoda (Level 1) -> 0 stars, Suvoriy (Level 2) -> 1 star
      stars = Math.max(0, darajaLevel - 1);
      const index = darajaLevel - 1;
      if (index >= 0 && index < titles.length) {
        title = titles[index];
      } else if (index >= titles.length) {
        title = titles[titles.length - 1];
      }
    } else {
      title = darajaRaw;
      // If it's a string, find its index in titles
      // Index 0 (Piyoda) should show 0 stars
      const index = titles.indexOf(darajaRaw);
      if (index !== -1) stars = index;
    }
  }

  // Create local user object to match previous structure for easier render compatibility
  const localUser = {
    title: title,
    stars: stars,
    tanga_balansi: tanga_balansi,
    tanga_jami: tanga_jami, // Added gross balance to localUser
    total_solved: total_solved,
    fio: displayFio,
    certificate_id: certificate_id
  };

  // State for dynamic certificate data (ID and Time)
  const [certData, setCertData] = useState({
    id: certificate_id,
    date: new Date().toLocaleDateString(),
    time: new Date().toLocaleTimeString()
  });

  useEffect(() => {
    if (triggerCert > 0) {
      handleShare();
    }
  }, [triggerCert]);

  const handleShare = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const token = localStorage.getItem("loyiha_token");

    if (!token) {
      toast.error("Tizimga kirmagansiz!");
      return;
    }

    // Debugging: Explicitly show if rank is insufficient
    if (total_solved < 2) {
      toast.error(`Sertifikat olish uchun kamida 2 ta masala yechilgan bo'lishi kerak. Sizda: ${total_solved}`);
      return;
    }

    // Call API to create/update certificate
    try {
      if (token && total_solved >= 2) {
        // toast.info("Ma'lumotlar yuklanmoqda...");
        const res = await fetch(`${CONFIG.API_BASE_URL}/sertifikat_yangilash.php`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }).then(r => r.json());

        if (res.status === 'success') {
          setCertData({
            id: res.certificate_id,
            date: res.date,
            time: res.time
          });
          // Update localUser for valid QR code generation immediately
          localUser.certificate_id = res.certificate_id;
          // toast.success("Sertifikat tayyor!");
          // Show certificate now that we have the ID
          setShowCert(true);
        } else {
          console.error("Cert Update Error:", res.message);
          if (res.message && res.message.includes("Insufficient rank")) {
            toast.error("Sertifikat olish uchun kamida 2 ta bo'lim tugatilgan bo'lishi kerak.");
          } else {
            toast.error("Xatolik: " + res.message);
          }

          // If we already have an ID from props, we can still show it
          if (localUser.certificate_id) {
            setShowCert(true);
          }
        }
      } else if (localUser.certificate_id) {
        // Just show existing if rank logic wasn't triggered
        setShowCert(true);
      }
    } catch (err) {
      console.error("Certificate update failed", err);
      toast.error("Serverga ulanishda xatolik: " + err.message);

      // Fallback: show if we already have it
      if (localUser.certificate_id) {
        setShowCert(true);
      }
    }
  };

  const closeCert = () => {
    setShowCert(false);
    setBgLoaded(false);
  };

  useEffect(() => {
    if (showCert) {
      setBgLoaded(false);
      const img = new Image();
      img.src = certificate_frame;
      img.onload = () => {
        setBgLoaded(true);
      };
      img.onerror = () => {
        setBgLoaded(true); // Proceed anyway to show content, though frame might be broken
      };
    }
  }, [showCert]);

  const downloadPDF = () => {
    const input = document.getElementById('certificate-node');
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      x: 0,
      y: 2, // Crop 2px from top to remove artifact
      width: input.offsetWidth,
      height: input.offsetHeight - 4, // Crop 2px from bottom too
      backgroundColor: null
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('l', 'mm', 'a4'); // Landscape
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save("Algoritm_Sertifikat.pdf");
    });
  };

  const downloadJPG = () => {
    const input = document.getElementById('certificate-node');
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      x: 0,
      y: 2, // Crop 2px from top to remove artifact
      width: input.offsetWidth,
      height: input.offsetHeight - 4, // Crop 2px from bottom too
      backgroundColor: null
    }).then((canvas) => {
      const link = document.createElement('a');
      link.download = 'Algoritm_Sertifikat.jpg';
      link.href = canvas.toDataURL('image/jpeg', 1.0); // Use quality 1.0
      link.click();
    });
  };

  return (
    <div className="foydalanuvchi-daraja-quti">
      <span>
        Mantiqiy masala darajasi{" "}
        <a href="#" onClick={(e) => { e.preventDefault(); onStatsClick(); }} title="Statistika">
          <FaChartLine className="daraja-yuborish" />
        </a>
      </span>
      <div className="foydalanuvchi-mantiq-icon">
        {[...Array(titles.length)].map((_, i) => {
          const isLit = i < localUser.stars;
          const isTarget = i === localUser.stars;
          return (
            <div
              key={i}
              className={(isLit ? "sariq" : (isTarget ? "star-target star-wrapper" : "star-wrapper")) + (i === 0 ? " star-first" : "")}
              style={{
                position: 'relative',
                cursor: isTarget ? 'help' : 'default',
                transition: 'all 0.3s ease',
                color: isLit ? "rgb(141, 71, 21)" : (isTarget ? "#ccc" : "rgba(0, 0, 0, 0.4)")
              }}
            >
              <FaStar />
              {isTarget && (
                <div className="custom-tooltip">
                  Algoritm balli: {formatSumma(localUser.tanga_jami !== undefined ? localUser.tanga_jami : localUser.tanga_balansi)}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {showCert && (
        <div className="certificate-modal-overlay" style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex',
          flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ marginBottom: '10px', width: '95vw', maxWidth: '800px', display: 'flex', justifyContent: 'flex-end' }}>
            <button onClick={closeCert} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '24px', cursor: 'pointer' }}><FaTimes /></button>
          </div>

          {/* Certificate Content Node */}
          <div id="certificate-node" className="certificate-container" style={{
            position: 'relative',
            width: '95vw',
            maxWidth: '800px',
            height: '565px', // A4 Landscape ratio
            padding: '40px',
            backgroundColor: '#fff', // White background behind frame
            backgroundImage: bgLoaded ? `url(${certificate_frame})` : 'none',
            backgroundPosition: 'center',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: '#333',
            boxShadow: '0 0 50px rgba(0,0,0,0.5)',
            fontFamily: "'Roboto Mono', monospace", // Global font Roboto Mono
            overflow: 'hidden'
          }}>
            {!bgLoaded && (
              <div className="cert-loading-overlay">
                <div className="cert-spinner"></div>
                <span>Sertifikat tayyorlanmoqda...</span>
              </div>
            )}
            {/* Faint Center Logo Watermark */}
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.05, // Even fainter
              width: '500px', // Larger
              height: '500px',
              backgroundImage: `url(${logo})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              zIndex: 0,
              pointerEvents: 'none'
            }}></div>

            <div style={{ zIndex: 1, textAlign: 'center', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingBottom: '20px' }}>
              <div>
                <h1 style={{ fontSize: '42px', color: 'rgb(141, 71, 21)', margin: '80px 0 0 0', textTransform: 'uppercase', letterSpacing: '4px', fontFamily: "'Playfair Display', serif", fontWeight: '900' }}>ALGORITM DARAJASI</h1>

                <p style={{ fontSize: '18px', margin: '10px 0' }}>Muvaffaqiyat guvohnomasi beriladi:</p>
                <h2 style={{ fontSize: '22px', margin: '10px 0', color: '#000', borderBottom: '1px solid rgb(141, 71, 21)', display: 'inline-block', paddingBottom: '5px', fontWeight: '700' }}>
                  {localUser.fio}
                </h2>

                <p style={{ fontSize: '16px', margin: '15px auto', maxWidth: '70%' }}>
                  <b>Suvoriy.com</b> platformasida “Algoritm va Mantiq” bosqichi doirasida faol ishtirok etib, algoritmik fikrlash va mantiqiy tahlil bo‘yicha bilim darajasini muvaffaqiyatli namoyon etgani uchun.
                </p>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '80px', margin: '30px 0' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: 'rgb(141, 71, 21)', marginBottom: '-8px' }}><FaChessKnight /></div>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'rgb(141, 71, 21)' }}>{localUser.title}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: 'rgb(141, 71, 21)', marginBottom: '-8px' }}><FaCheckCircle /></div>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'rgb(141, 71, 21)' }}>{localUser.total_solved}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: 'rgb(141, 71, 21)', marginBottom: '-8px' }}><FaGem /></div>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'rgb(141, 71, 21)' }}>{formatSumma(localUser.tanga_jami)}</div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'end', width: '100%', paddingLeft: '50px', marginBottom: '200px', marginTop: '-120px' }}>
                <div style={{ textAlign: 'center' }}>
                  <div
                    onClick={() => {
                      const cid = certData.id || localUser.certificate_id;
                      if (cid) {
                        window.open(`https://suvoriy.com/verify-id/AL${encodeCertId(cid)}`, '_blank');
                      }
                    }}
                    style={{ background: '#fff', padding: '5px', display: 'inline-block', border: '1px solid #ddd', cursor: 'pointer' }}
                    title="Tekshirish sahifasini ochish"
                  >
                    {/* Use ID-based verification if ID exists, else fallback or empty? User wants ID based. */}
                    {(certData.id || localUser.certificate_id) ? (
                      <QRCodeCanvas
                        key={certData.id || localUser.certificate_id}
                        value={`https://suvoriy.com/verify-id/AL${encodeCertId(certData.id || localUser.certificate_id)}`}
                        size={80}
                      />
                    ) : (
                      /* Fallback or placeholder while loading ID */
                      <QRCodeCanvas value={`https://suvoriy.com/verify-loading`} size={80} />
                    )}
                  </div>
                  <div style={{ fontSize: '10px', marginTop: '4px', color: '#666' }}>
                    <><span style={{ fontWeight: 'bold', display: 'block', marginBottom: '2px', color: '#000' }}>ID: AL{String(certData.id || localUser.certificate_id).padStart(6, '0')}</span></>
                    {certData.date} <br />
                    {certData.time}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="cert-actions" style={{ marginTop: '20px', display: 'flex', gap: '20px' }}>
            <button onClick={downloadPDF} className="cert-btn save-pdf">
              <FaFilePdf /> PDF Saqlash
            </button>
            <button onClick={downloadJPG} className="cert-btn save-jpg">
              <FaFileImage /> JPG Saqlash
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
